module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/limited_products-54a5f50d7dcf401e1b6bf657e7fe15ee.png";